import React from "react";
import Button from "@mui/material/Button";

const LoginButton = ({ handleSetAuthenticationIsOpen }) => (
  <Button
    variant="text"
    onClick={() => {
      handleSetAuthenticationIsOpen("LOGIN");
    }}
    sx={{
      borderRadius: "9px",
      padding: "6px 16px",
      fontFamily: '"Inter", "Roboto", "Helvetica", sans-serif',
      fontWeight: 600,
      fontSize: "14px",
      textTransform: "none",
      whiteSpace: "nowrap",
    }}
  >
    Log in
  </Button>
);

export default LoginButton;
